// Firebase
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCTIomKD3pkLgedZO33WD-lyKV1ZsRLOhA",
  authDomain: "smart-planting-system-114af.firebaseapp.com",
  databaseURL: "https://smart-planting-system-114af-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "smart-planting-system-114af",
  storageBucket: "smart-planting-system-114af.firebasestorage.app",
  messagingSenderId: "1059650956056",
  appId: "1:1059650956056:web:dbb7f9f6268e094b554c6d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
const database = getDatabase(app);

// Export database
export { database };